document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-as-skin-slider]");

  sections.forEach((section) => {
    const wrapper = section.querySelector(".as-skin-reviews__track-wrapper");
    const track = section.querySelector(".as-skin-reviews__track");

    if (!wrapper || !track || !track.children.length) return;

    const autoScrollEnabled = section.dataset.autoscroll === "true";
    const speed = parseFloat(section.dataset.speed) || 0.5;

    let position = 0;
    let isPaused = false;
    let isDragging = false;
    let isVisible = false;
    let lastX = 0;
    let animationFrame = null;
    let gap = 0;

    function updateGap() {
      gap = parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getItemWidth(item) {
      return item.getBoundingClientRect().width + gap;
    }

    function handleLoop() {
      let firstItem = track.children[0];
      if (!firstItem) return;

      let firstWidth = getItemWidth(firstItem);

      while (-position >= firstWidth) {
        position += firstWidth;
        track.appendChild(firstItem);

        firstItem = track.children[0];
        if (!firstItem) return;

        firstWidth = getItemWidth(firstItem);
      }

      while (position > 0) {
        const lastItem = track.children[track.children.length - 1];
        if (!lastItem) return;

        const lastWidth = getItemWidth(lastItem);

        position -= lastWidth;
        track.insertBefore(lastItem, track.firstChild);
      }
    }

    function render() {
      handleLoop();
      track.style.transform = `translate3d(${position}px, 0, 0)`;
    }

    function startAnimation() {
      if (animationFrame || !autoScrollEnabled || !isVisible) return;

      function animate() {
        if (!isPaused && !isDragging) {
          position -= speed;
          render();
        }

        animationFrame = requestAnimationFrame(animate);
      }

      animationFrame = requestAnimationFrame(animate);
    }

    function stopAnimation() {
      if (!animationFrame) return;

      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    function getClientX(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    }

    function dragStart(event) {
      if (event.target.closest(".as-skin-reviews__play")) return;

      isDragging = true;
      lastX = getClientX(event);
      track.classList.add("is-dragging");

      stopAnimation();
    }

    function dragMove(event) {
      if (!isDragging) return;

      const currentX = getClientX(event);
      const delta = currentX - lastX;

      lastX = currentX;
      position += delta;

      render();
    }
    function dragEnd() {
      if (!isDragging) return;

      isDragging = false;
      track.classList.remove("is-dragging");

      track.style.transition = "none";
      render();

      if (!isPaused) startAnimation();
    }

    wrapper.addEventListener("mouseenter", () => {
      isPaused = true;
      stopAnimation();
    });

    wrapper.addEventListener("mouseleave", () => {
      isPaused = false;
      startAnimation();
    });

    wrapper.addEventListener("mousedown", dragStart);
    window.addEventListener("mousemove", dragMove);
    window.addEventListener("mouseup", dragEnd);

    wrapper.addEventListener("touchstart", dragStart, { passive: true });
    wrapper.addEventListener("touchmove", dragMove, { passive: true });
    wrapper.addEventListener("touchend", dragEnd);

    window.addEventListener("resize", () => {
      updateGap();
      render();
    });

    updateGap();
    render();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting;

          if (isVisible && !isPaused && !isDragging) {
            startAnimation();
          } else {
            stopAnimation();
          }
        });
      },
      {
        threshold: 0.1,
      },
    );

    observer.observe(section);
  });

  document.addEventListener("click", (event) => {
    const playButton = event.target.closest(".as-skin-reviews__play");
    if (!playButton) return;

    const card = playButton.closest(".as-skin-reviews__card");
    const video = card ? card.querySelector("video") : null;

    if (!video) return;

    if (video.paused) {
      video.controls = true;
      video.muted = false;
      video.play();
      playButton.classList.add("is-playing");
    } else {
      video.pause();
      playButton.classList.remove("is-playing");
    }
  });
});
